import { AnalyticsSelectedProductType } from "@intelligems/ig-types/schemas/analytics/base";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getExperienceAnalyticsFilters } from "@src/store/slices/dashboardFilters";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const openSelectedAnalyticsProductPicker = createAsyncThunk<
  void,
  AnalyticsSelectedProductType[]
>(
  "productPicker/openSelectedAnalyticsProductPicker",
  async (dialogFilerProducts, { dispatch, getState }) => {
    dispatch(openProductPicker({ type: "selectedAnalyticsProducts" }));

    const dashboardFilters = getExperienceAnalyticsFilters(getState());
    const baseProductFormatted: ProductPickerSelectedProduct[] = [
      ...dialogFilerProducts,
      ...dashboardFilters.selectedAnalyticsProducts,
    ]
      .map((p) => {
        return {
          ...p,
          image: undefined,
          requiresSellingPlan: undefined,
          title: p.title || "",
          handle: p.handle || "",
        };
      })
      .filter(
        (p, index, self) => index === self.findIndex((pp) => pp.id === p.id)
      );

    dispatch(setProductPickerSelectedProducts(baseProductFormatted));
  }
);
